import useAppConfig from '../use-app-config';

export const useIsAgeGenderEnabled = () => {
    const {
        NEXT_PUBLIC_AGE_GENDER_ENABLED_ISO_DATETIME: ageGenderEnabledDate,
    } = useAppConfig();

    return ageGenderEnabledDate <= new Date();
};
